/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,

  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_DATA_COPY,
  LOAD_DATA_COPY_SUCCESS,
  LOAD_DATA_COPY_ERROR,


  LOAD_DATA_LINK_DETAILS,
  LOAD_DATA_LINK_DETAILS_SUCCESS,
  LOAD_DATA_LINK_DETAILS_ERROR,

  UPLOAD_QC,
  UPLOAD_QC_SUCCESS,
  UPLOAD_QC_ERROR,

  DELETE_STATUS,
  DELETE_STATUS_SUCCESS,
  DELETE_STATUS_ERROR


} from "./constants"
//LOAD_DATA_COPY
export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}


export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}


export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//permission list    loadDataCopy
export function loadDataCopy(searchvalue) {
  return {
    type: LOAD_DATA_COPY,
    searchvalue,
  }
}
export function loadDataCopySuccess(data_copy_details) {
  return {
    type: LOAD_DATA_COPY_SUCCESS,
    data_copy_details,
  }
}
export function loadDataCopyError(error) {
  return {
    type: LOAD_DATA_COPY_ERROR,
    error,
  }
}


//Data link section
export function loadDataLinkList(record) {
  return {
    type: LOAD_DATA_LINK_DETAILS,
    record,
  }
}

export function loadDataLinkListSuccess(data_link_details) {
  return {
    type: LOAD_DATA_LINK_DETAILS_SUCCESS,
    data_link_details,
  }
}



export function loadDataLinkListError(error) {
  return {
    type: LOAD_DATA_LINK_DETAILS_ERROR,
    error,
  }
}


//uploadQc
export function uploadQc(qcDetails) {

  return {
    type: UPLOAD_QC,
    qcDetails,
  }
}


export function uploadQcSuccess(success) {

  return {
    type: UPLOAD_QC_SUCCESS,
    success,
  }
}


export function uploadQcError(error) {
  return {
    type: UPLOAD_QC_ERROR,
    error,
  }
}
//deleteStatus
export function deleteStatus(deleteStatus) {

  return {
    type: DELETE_STATUS,
     deleteStatus,
  }
}


export function deleteStatusSuccess(success) {

  return {
    type: DELETE_STATUS_SUCCESS,
    success,
  }
}


export function deleteStatusError(error) {
  return {
    type: DELETE_STATUS_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadDataCopy,
  loadDataCopySuccess,
  loadDataCopyError,


  //Data link
  loadDataLinkList,
  loadDataLinkListSuccess,
  loadDataLinkListError,


  uploadQc,
  uploadQcSuccess,
  uploadQcError,
 
  deleteStatus,
  deleteStatusSuccess,
  deleteStatusError

}

export default actions
